/* AURALYS — interacciones propias (prefijo au-) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.au-reveal, .au-ritual__media');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('au-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('au-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initCountUp() {
    var els = document.querySelectorAll('[data-au-count]');
    if (!els.length) return;
    function run(el) {
      var to = parseFloat(el.getAttribute('data-au-count')) || 0;
      var prefix = el.getAttribute('data-au-prefix') || '';
      var suffix = el.getAttribute('data-au-suffix') || '';
      if (reduce) { el.textContent = prefix + to + suffix; return; }
      var start = null, dur = 1600;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = prefix + Math.round(to * eased) + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initLed() {
    document.querySelectorAll('[data-au-led]').forEach(function (root) {
      var dots = root.querySelectorAll('.au-led__dot');
      var name = root.querySelector('.au-led__name');
      var desc = root.querySelector('.au-led__desc');
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          dots.forEach(function (d) { d.setAttribute('aria-pressed', 'false'); });
          dot.setAttribute('aria-pressed', 'true');
          root.style.setProperty('--au-led-color', dot.getAttribute('data-color'));
          if (name) name.textContent = dot.getAttribute('data-name');
          if (desc) desc.textContent = dot.getAttribute('data-desc');
        });
      });
    });
  }

  function initGallery() {
    document.querySelectorAll('[data-au-gallery]').forEach(function (g) {
      var main = g.querySelector('.au-gallery__main img');
      var thumbs = Array.prototype.slice.call(g.querySelectorAll('.au-gallery__thumb'));
      if (!main || !thumbs.length) return;
      var idx = 0;
      function show(i) {
        idx = (i + thumbs.length) % thumbs.length;
        var t = thumbs[idx];
        main.style.opacity = 0;
        setTimeout(function () {
          main.src = t.getAttribute('data-src');
          main.alt = t.getAttribute('data-alt') || '';
          main.style.opacity = 1;
        }, 150);
        thumbs.forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
      }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
      var prev = g.querySelector('.au-gallery__nav--prev');
      var next = g.querySelector('.au-gallery__nav--next');
      if (prev) prev.addEventListener('click', function () { show(idx - 1); });
      if (next) next.addEventListener('click', function () { show(idx + 1); });
      g._auShow = show;
      g._auThumbs = thumbs;
    });
  }

  function initBuy() {
    document.querySelectorAll('[data-au-buy]').forEach(function (root) {
      var qty = root.querySelector('.au-qty input');
      var packs = root.querySelectorAll('[data-au-pack]');
      function syncPack() {
        var q = parseInt(qty.value, 10) || 1;
        packs.forEach(function (p) { p.checked = (q >= 2 ? '2' : '1') === p.value; });
      }
      packs.forEach(function (p) {
        p.addEventListener('change', function () { if (p.checked) qty.value = p.value; });
      });
      root.querySelectorAll('.au-qty button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(qty.value, 10) || 1;
          qty.value = Math.max(1, v + parseInt(b.getAttribute('data-step'), 10));
          syncPack();
        });
      });
      if (qty) qty.addEventListener('input', syncPack);

      var dataEl = root.querySelector('[data-au-variants]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var idInput = root.querySelector('input[name="id"]');
      var priceNow = root.querySelectorAll('[data-au-price]');
      var priceOld = root.querySelectorAll('[data-au-compare]');
      var buttons = document.querySelectorAll('[data-au-add]');
      var format = root.getAttribute('data-money-format') || '{{amount}} €';
      var txtAdd = root.getAttribute('data-txt-add');
      var txtSold = root.getAttribute('data-txt-sold');

      function money(cents) {
        var n = (cents / 100).toFixed(2);
        var withComma = n.replace('.', ',');
        return format.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
                     .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100))
                     .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
                     .replace(/\{\{\s*amount\s*\}\}/, n);
      }

      root.querySelectorAll('.au-variant input').forEach(function (inp) {
        inp.addEventListener('change', function () {
          var chosen = [];
          root.querySelectorAll('.au-variant').forEach(function (fs) {
            var c = fs.querySelector('input:checked');
            chosen.push(c ? c.value : null);
          });
          var v = variants.filter(function (x) {
            return x.options.every(function (o, i) { return o === chosen[i]; });
          })[0];
          if (!v) return;
          idInput.value = v.id;
          priceNow.forEach(function (el) { el.textContent = money(v.price); });
          priceOld.forEach(function (el) {
            if (v.compare_at_price && v.compare_at_price > v.price) { el.textContent = money(v.compare_at_price); el.hidden = false; }
            else { el.hidden = true; }
          });
          buttons.forEach(function (b) {
            b.disabled = !v.available;
            var label = b.querySelector('[data-au-add-label]');
            if (label) label.textContent = v.available ? txtAdd : txtSold;
          });
          if (v.featured_media_position) {
            var g = document.querySelector('[data-au-gallery]');
            if (g && g._auShow) g._auShow(v.featured_media_position - 1);
          }
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        });
      });
    });
  }

  function initStickyBar() {
    var bar = document.querySelector('.au-sticky-bar');
    var anchor = document.querySelector('.au-buy__add');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var below = e.boundingClientRect.top < 0;
        bar.classList.toggle('au-show', !e.isIntersecting && below);
      });
    });
    io.observe(anchor);
    var btn = bar.querySelector('button');
    if (btn) btn.addEventListener('click', function () {
      var form = document.querySelector('[data-au-buy] form');
      if (form) { if (form.requestSubmit) form.requestSubmit(); else form.submit(); }
    });
  }

  function init() {
    initReveal();
    initCountUp();
    initLed();
    initGallery();
    initBuy();
    initStickyBar();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
